<template>
  <div class="content">
    <card class="text-left">
      <template slot="header">
        <h4 class="card-title">서포트 요청 관리</h4>
        <p class="card-category">사용자의 서포트 요청 현황을 조회합니다. (읽기 전용)</p>
      </template>
      <div class="row">
        <ArtistSelect
          class="col-md-7"
          :initial-unit-id="0"
          :include-unit-artist="false"
          :show-all-units="true"
          :show-members="false"
          :is-multiple="false"
          @unitChangeEvent="onUnitChange"
        />
        <div class="col-md-2">
          <label class="col-form-label">&nbsp;</label>
          <base-button @click="search" type="default" block>검색</base-button>
        </div>
      </div>
    </card>

    <card class="text-left">
      <template slot="header">
        <h4 class="card-title">스케줄별 집계</h4>
      </template>
      <div class="row">
        <el-table :data="summary" style="width: 100%">
          <el-table-column prop="scheduleName" label="스케줄명" :min-width="220">
            <template slot-scope="props">{{ props.row.scheduleName || "-" }}</template>
          </el-table-column>
          <el-table-column prop="artistHomeName" label="아티스트" :min-width="140">
            <template slot-scope="props">{{ props.row.artistHomeName || "-" }}</template>
          </el-table-column>
          <el-table-column prop="requestCount" label="요청수" :min-width="80" align="right">
            <template slot-scope="props">{{ Number(props.row.requestCount || 0).toLocaleString() }}</template>
          </el-table-column>
        </el-table>
      </div>
    </card>

    <card class="text-left">
      <template slot="header">
        <h4 class="card-title">요청 목록</h4>
      </template>
      <div class="row">
        <el-table :data="data" style="width: 100%">
          <el-table-column prop="userName" label="유저명" :min-width="140">
            <template slot-scope="props">{{ props.row.userName || "-" }}</template>
          </el-table-column>
          <el-table-column prop="artistHomeName" label="아티스트홈" :min-width="140">
            <template slot-scope="props">{{ props.row.artistHomeName || "-" }}</template>
          </el-table-column>
          <el-table-column prop="scheduleName" label="스케줄명" :min-width="220">
            <template slot-scope="props">{{ props.row.scheduleName || "-" }}</template>
          </el-table-column>
          <el-table-column label="요청일시" :min-width="170">
            <template slot-scope="props">{{ formatDateTime(props.row.regTime) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="row">
        <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
      </div>
    </card>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { Card, BaseButton, BasePagination } from "@/components/index";
import { formatDateTime } from "@/util/DateUtils";

export default {
  components: {
    Card,
    BaseButton,
    BasePagination,
    ArtistSelect,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    await Promise.all([this.getRequests(), this.getSummary()]);
  },
  data() {
    return {
      data: [],
      summary: [],
      unitId: null,
      currentPage: 1,
      totalPages: null,
      limit: 20,
    };
  },
  watch: {
    currentPage() {
      this.getRequests(this.currentPage);
    },
  },
  methods: {
    formatDateTime,
    onUnitChange(param) {
      this.unitId = param && param.unitId ? param.unitId : null;
    },
    search() {
      this.currentPage = 1;
      this.getRequests(1);
      this.getSummary();
    },
    async getRequests(page) {
      const params = { page: page ? page : 1, limit: this.limit };
      if (this.unitId) params.unitId = this.unitId;
      return this.$axios.get("/fundingPoll/requests", { params }).then((res) => {
        const payload = res.data.data;
        this.data = payload.data;
        const total = payload.meta ? payload.meta.total : 0;
        this.totalPages = Math.max(1, Math.ceil(total / this.limit));
      });
    },
    async getSummary() {
      const params = {};
      if (this.unitId) params.unitId = this.unitId;
      return this.$axios.get("/fundingPoll/requests/summary", { params }).then((res) => {
        this.summary = res.data.data.data;
      });
    },
  },
};
</script>
<style scoped></style>
